import React from "react";
import Marquee from "react-fast-marquee";
import { CLIENTS } from "../data/site";

const ClientLogo = ({ logo }) => (
  <div
    data-testid={`client-logo-${logo.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className="mx-8 lg:mx-12 h-16 w-44 flex items-center justify-center"
    title={logo.name}
  >
    <img
      src={logo.url}
      alt={logo.name}
      loading="lazy"
      onError={(e) => {
        // Fallback to a typographic logo if Clearbit fails
        const parent = e.target.parentElement;
        if (parent && !parent.dataset.fallback) {
          parent.dataset.fallback = "1";
          parent.innerHTML = `<span class='font-display font-bold text-zinc-700 text-base tracking-tight whitespace-nowrap'>${logo.name}</span>`;
        }
      }}
      className="client-logo max-h-12 max-w-[160px] object-contain"
    />
  </div>
);

const ClientsMarquee = ({ heading = "Trusted by enterprises across Asia-Pacific" }) => {
  return (
    <section
      data-testid="clients-marquee"
      className="border-y border-black/10 bg-white py-14"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-10">
        <p className="text-xs tracking-[0.22em] uppercase text-zinc-500 font-medium">
          {heading}
        </p>
      </div>
      <Marquee gradient gradientColor="#ffffff" gradientWidth={80} speed={32} pauseOnHover>
        {CLIENTS.map((c) => (
          <ClientLogo key={c.name} logo={c} />
        ))}
      </Marquee>
    </section>
  );
};

export default ClientsMarquee;
